import { authState } from "recoil/auth";
import { useRecoilValue } from "recoil";
import Api from "..";

const Xlsx = () => {
  const auth = useRecoilValue(authState);

  return {
    getXlsxDownloadHref,
    getDownloadResult,
    getBlobWithToken,
  };

  // 응시현황
  async function getXlsxDownloadHref(isTestRoomSn, filename) {
    const res = await getBlobWithToken("admin/excel/getRoomExcel", {
      room_sn: isTestRoomSn,
    }).then((response) => {
      const href = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", filename + ".xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });
  }

  // 평가결과 저장
  async function getDownloadResult(isTestRoomSn, filename) {
    // console.log("download", isTestRoomSn, filename);
    const res = await getBlobWithToken("admin/evaluationResultExcel", {
      room_sn: isTestRoomSn,
    }).then((response) => {
      if (response.status == 200) {
        const href = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", filename + ".xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      } else {
        alert("평가결과 저장 실패.");
      }
    });
  }

  async function getBlobWithToken(url, params) {
    if (!auth.token) {
      alert("no token");
      return;
    }
    const res = await Api.get(url, {
      params,
      accesstoken: auth.token.accesstoken,
      responseType: "blob",
    }).catch((err) => {
      console.log(err);
      return err.response;
    });
    return res;
  }
};

export default Xlsx;
